{
  "phone-number-input": {
    "text": {
      "country-code": "Mã quốc gia",
      "country-code-invalid": "Không hợp lệ",
      "country-code-required": "Bắt buộc",
      "phone-nr": "Số điện thoại",
      "phone-nr-invalid": "Số điện thoại di động không hợp lệ",
      "phone-nr-required": "Số điện thoại là bắt buộc"
    }
  }
}
